import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';
import { StyledHeader, StyledHeading2, StyledParagraph } from './ReplenishmentTooltipModalStyles';
import {
    replenishmentHeadingModalClass,
    replenishmentSubtitleModalClass,
    translationsList
} from './utils';

export const ReplenishmentTooltipModalHeader = observer(() => {
    const { subscribeAndSaveDiscount, getProductOnScheduleCancelAnytime } =
        useTranslation(translationsList);

    return (
        <StyledHeader>
            <StyledHeading2 className={replenishmentHeadingModalClass} data-content="title">
                {subscribeAndSaveDiscount}
            </StyledHeading2>
            <StyledParagraph className={replenishmentSubtitleModalClass} data-content="text">
                {getProductOnScheduleCancelAnytime}
            </StyledParagraph>
        </StyledHeader>
    );
});
